import { render, staticRenderFns } from "./TechnicalDetail.vue?vue&type=template&id=b72ca3d8&scoped=true"
import script from "./TechnicalDetail.vue?vue&type=script&lang=js"
export * from "./TechnicalDetail.vue?vue&type=script&lang=js"
import style0 from "./TechnicalDetail.vue?vue&type=style&index=0&id=b72ca3d8&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72ca3d8",
  null
  
)

export default component.exports